module.exports = __webpack_public_path__ + "assets/img/jykj_img.d4219ac9.png";